import {
  Box,
  Button,
  ButtonProps,
  List,
  Typography,
  darken,
  styled,
  useTheme,
} from '@mui/material';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import DocumentListItem from '../../components/lists/DokumentListItem';
import useDocuments from '../../hooks/useDocuments';
import useMedia from '../../hooks/useMedia';

const StyledButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.background.paper,
  borderRadius: '3px',
  minWidth: '200px',

  // on hover change background color
  '&:hover': {
    backgroundColor: darken(theme.palette.primary.main, 0.4),
    color: theme.palette.background.paper,
  },
}));

const DashDocuments: FC = observer(() => {
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMedia('md');

  const { documentsFromTiles } = useDocuments(true, true);

  const documents = useDocuments();

  const tranformendUnreadDocuments = documentsFromTiles
    .map(item =>
      item?.documents.map(document => ({
        document,
        tileTitle: item.tileTitle,
      })),
    )
    .flat();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        alignItems: 'center',
        backgroundColor: 'primary.main',
        borderRadius: '3px',
        marginTop: isMobile ? '20px' : '40px',
      }}
    >
      <Box marginTop={3}>
        <Typography variant="h6" color="white">
          Ungelesene Dokumente
        </Typography>
      </Box>

      <Box
        width={1}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
        p={isMobile ? 0 : 2}
        pt={2}
        pb={2}
      >
        <Box width={1} p={isMobile ? 1 : 2}>
          {tranformendUnreadDocuments?.length === 0 && (
            <Typography variant="body1" color="#fff">
              Keine ungelesenen Dokumente
            </Typography>
          )}
          <List>
            {tranformendUnreadDocuments
              ?.sort(
                (a, b) =>
                  moment(a.document.datum).valueOf() -
                  moment(b.document.datum).valueOf(),
              )
              .reverse()
              .map(item => {
                if (item?.document)
                  return (
                    <DocumentListItem
                      key={item.document.name}
                      textColor="#fff"
                      onDocumentClick={() =>
                        documents.downloadDocument(item.document)
                      }
                      bgHoverColor={darken(theme.palette.primary.main, 0.4)}
                      document={item.document}
                      documentGroupName={item.tileTitle}
                    />
                  );
                return null;
              })}
          </List>
        </Box>
        <StyledButton
          variant="contained"
          onClick={() => navigate('/dokumente')}
        >
          Zur Übersicht
        </StyledButton>
      </Box>
    </Box>
  );
});

export default DashDocuments;
